
import React from "react";
import { Badge } from "@/components/ui/badge";
import { CheckCircle, XCircle } from "lucide-react";

interface StatusBadgeProps {
  condition: boolean;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ condition }) => {
  return condition ? (
    <Badge variant="success" className="bg-green-500">
      <CheckCircle className="h-3 w-3 mr-1" /> Yes
    </Badge>
  ) : (
    <Badge variant="destructive">
      <XCircle className="h-3 w-3 mr-1" /> No
    </Badge>
  );
};

export default StatusBadge;
